<boma-crud-table
  (queryChanged)="search($event)"
  (viewSelection)="onViewSelection($event)"
  [data]="users$ | async"
  [displaySearchBar]="true"
  [headersValue]="'User'"
  [loaded]="loaded$ | async"
  [selectableColumns]="columns"
  [viewable]="true"
>
</boma-crud-table>
